import { DashboardCard } from "../../../Dashboard/DashboardCard";

import Subscription from "./Subscription";
import EmailNotifications from "./EmailNotifications";
import SentEmailHistory from "./SentEmailHistory";

interface ClientSubscriptionProps {
  userId: string;
}

export default function ClientSubscription({
  userId,
}: ClientSubscriptionProps) {
  return (
    <DashboardCard className="bg-admin-bg w-full cursor-default gap-5 p-0">
      <Subscription userId={userId} />
      <EmailNotifications />
      <SentEmailHistory />
    </DashboardCard>
  );
}
